var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn route-button col-xl-3 col-md-5 col-12",attrs:{"href":_vm.href}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }